import React from 'react'
import { TextTooltip } from '../InfoPopup'
import { Badge } from '../Badge'

interface BetaPillProps {
  label: string
  tooltip?: string
}

export const BetaPill: React.FC<BetaPillProps> = ({ label, tooltip }) => {
  return (
    <TextTooltip tooltip={tooltip} placement="bottom-start">
      <Badge type="info">{label}</Badge>
    </TextTooltip>
  )
}
